<script>
export default {
  render: () => null
}
</script>

<script setup>
import { useToast, TYPE as TOAST_TYPE } from 'vue-toastification'
import { watch } from 'vue'

const props = defineProps({
  flash: {
    default: null
  }
})

const toast = useToast()

watch(
  () => props.flash,
  (flash) => {
    if (flash?.success) {
      toast(flash.success, { type: TOAST_TYPE.SUCCESS })
    }
  }
)
</script>
